import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiV2ReservationusernoteElFindParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiV2ReservationusernoteElFindParams, unknown>

const fetchReservationUserNoteList = async (params: ApiV2ReservationusernoteElFindParams) => {
  const { data } = await apiClient.v2.apiV2ReservationusernoteElFind(params);
  return checkApiResponse(data);
}

export const v2ReservationUserNoteKeys = {
  all: [QUERY_KEY.v2apiV2ReservationusernoteElFind] as const,
  list: (params: ApiV2ReservationusernoteElFindParams) => [...v2ReservationUserNoteKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(v2ReservationUserNoteFindQueryOptions(params))` */
export const v2ReservationUserNoteFindQueryOptions = (params: ApiV2ReservationusernoteElFindParams) => ({
  queryKey: v2ReservationUserNoteKeys.list(params),
  queryFn: () => fetchReservationUserNoteList(params),
})

export const useV2ReservationUserNoteFindQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: v2ReservationUserNoteKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchReservationUserNoteList(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
